<rask-button
    class="col-3 text-center"
    color="secondary"
    (click)="makulera()"
    [disabled]="!canMakulera">
    Makulera arbetsorder
</rask-button>
